import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

class DefaultLink extends Component {
	constructor() {
		super();

		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		if (this.props.itemProps.hasSubMenu) {
			this.props.itemProps.toggleSubMenu(e)
		} else {

			this.props.itemProps.activateMe({
				newLocation: this.props.to,
				selectedMenuLabel: this.props.label,
			});
		}
	}
	/**
	 * Une entrée est active si elle correspond exactement à la page (chemin et paramètres) ; une entrée à
	 * sous-menu n'est jamais « active » elle-même (sinon elle l'est toujours, ses liens étant vides).
	 */
	isActive = (match, location) => {
		const { itemProps } = this.props;
		if (itemProps.hasSubMenu || !itemProps.to) return false;
		const target = String(itemProps.to);
		return target.includes('?')
			? `${location.pathname}${location.search}` === target
			: (location.pathname === target || (target !== '/' && location.pathname.startsWith(`${target}/`))) && !location.search;
	}

	render() {
		const { itemProps, badge } = this.props
		const badgeEl = badge > 0 ? <span className="app-sidebar__badge" title={String(badge)}>{badge > 99 ? '99+' : badge}</span> : null;
		if (String(itemProps.id).startsWith('header-')) {
			return <span className="app-sidebar__section">{itemProps.label}</span>;
		}
		if (itemProps.id === 'main' || itemProps.id === 'app' || itemProps.id === 'extra' || itemProps.id === 'ui') {
			return (
				itemProps.label
			);
		} else {
			return (
				itemProps.children[0].props.className ?
					<NavLink to={`${itemProps.to}`} onClick={(e) => this.onClick(e)} isActive={this.isActive} className={`${itemProps.hasSubMenu ? "has-arrow" : ""}`}>
						<i className={itemProps.children[0].props.className}></i>
						<span>{itemProps.label}</span>
						{badgeEl}
					</NavLink> :
					<NavLink to={`${itemProps.to}`} onClick={(e) => this.onClick(e)} isActive={this.isActive}>
						<span>{itemProps.label}</span>
						{badgeEl}
					</NavLink>
			);
		}
	}
};
const mapStateToProps = state => ({
	subMenuIcon: state.settings.isSubMenuIcon,
	menuIcon: state.settings.isMenuIcon
})

const mapDispatchToProps = dispatch => ({})
export default connect(mapStateToProps, mapDispatchToProps)(DefaultLink);